/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Typography, Button, CircularProgress } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SCROLL_THRESHOLD, MAX_AUDIO_RETENTION_PERIOD } from '@src/constants';
import routes from '@src/constants/route';
import actions from '@src/redux/actions';
import { DEFAULT_SYNTHESIS_REQUEST } from '@src/constants/voice';
import { StyledBtnCreate, StyledRequests } from './index.style';
import WarningRequestDialog from './Actions/WarningRequestDialog';
import Request from './Request';

const ButtonCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const onCreate = () => {
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(DEFAULT_SYNTHESIS_REQUEST),
    );
    dispatch(actions.audioPlayer.resetAudioPlayer());
    history.push(`${routes.MOBILE_TTS}?inSameSession=true`);
  };

  return (
    <StyledBtnCreate>
      <Button
        color="primary"
        variant="contained"
        className="btn-create-new"
        onClick={onCreate}
      >
        <AddRounded className="icon" />
        <Typography className="text-create-new">{t('createNew')}</Typography>
      </Button>
    </StyledBtnCreate>
  );
};

const Requests = ({
  requests,
  hasMore,
  loading,
  isShowInfoVCRequest,
  setPage,
  updateRequest,
  deleteRequest,
}) => {
  const refRequests = useRef(null);
  const history = useHistory();
  const { t } = useTranslation();

  const [showButtonCreate, setShowButtonCreate] = useState(true);
  const [openWarning, setOpenWarning] = useState(false);
  const [descriptionWarning, setDescriptionWarning] = useState('');

  const handleHideButtonCreate = () => setShowButtonCreate(false);
  const handleShowButtonCreate = () => setShowButtonCreate(true);

  const handlePushToMobileTTS = () => {
    history.push(routes.MOBILE_TTS);
  };

  // Fetch more requests when scroll to bottom
  const handleScroll = useCallback(() => {
    const { scrollHeight, scrollTop, clientHeight } = refRequests.current;
    if (
      scrollHeight - scrollTop <= clientHeight + SCROLL_THRESHOLD &&
      hasMore &&
      !loading
    ) {
      setPage((prevParams) => prevParams + 1);
    }
  }, [hasMore, loading]);

  // Add event listener to scroll event
  useEffect(() => {
    refRequests.current.addEventListener('scroll', handleScroll);
    return () => {
      refRequests.current?.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <StyledRequests ref={refRequests}>
      {requests.map((request) => (
        <Request
          request={request}
          handleHideButtonCreate={handleHideButtonCreate}
          handleShowButtonCreate={handleShowButtonCreate}
          updateRequest={updateRequest}
          deleteRequest={deleteRequest}
          setOpenWarning={setOpenWarning}
          setDescriptionWarning={setDescriptionWarning}
          isShowInfoVCRequest={isShowInfoVCRequest}
        />
      ))}
      {loading && (
        <div className="loading-row">
          <CircularProgress className="loading-progress" />
        </div>
      )}
      {showButtonCreate && <ButtonCreate />}
      <WarningRequestDialog
        title="note"
        description={descriptionWarning}
        open={openWarning}
        onClose={() => setOpenWarning(false)}
        onSure={handlePushToMobileTTS}
      />
    </StyledRequests>
  );
};

export default Requests;
